import React, { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  CartesianAxis,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  Flex,
  Heading,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import WeeklyEarningChart from "./WeeklyEarningChart";
import MonthlyEarningChart from "./MonthlyEarningChart";
import YearlyEarningChart from "./YearlyEarningChart";
import TotalEarningChart from "./TotalEarningChart";
import EarningsTable from "./EarningsTable";

const EarningChart = ({ data }) => {
  const [active, setActive] = useState("weekly");
  let toggleColor = useColorModeValue("#000", "#000");
  let tabBoxShadowColor = useColorModeValue(
    "-1px 20px 15px 0px #80808017",
    "9px 20px 20px 0px #fafafa12"
  );

  const tabstyle = {
    borderRadius: "10px",
    cursor: "pointer",
    boxShadow: tabBoxShadowColor,
    alignItems: "center",
    fontWeight: "100",
    fontSize: ".8em",
  };

  let act = {
    borderRadius: "10px",
    bg: "#0276fc",
    color: "#fff",
  };

  return (
    <div>
      <Stack direction={"row"} style={{ marginBottom: "15px" }}>
        <Stack
          direction="row"
          {...tabstyle}
          bg={"#fff"}
          justifyContent="space-between"
          color={toggleColor}
          width="100%"
        >
          <Text
            onClick={() => setActive("weekly")}
            p="10px 35px"
            {...(active === "weekly" ? act : {})}
            align={"center"}
            width="50%"
          >
            Weekly
          </Text>
          <Text
            onClick={() => setActive("monthly")}
            p="10px 35px"
            {...(active === "monthly" ? act : {})}
            align={"center"}
            width="50%"
          >
            Monthly
          </Text>

          <Text
            onClick={() => setActive("yearly")}
            p="10px 35px"
            {...(active === "yearly" ? act : {})}
            align={"center"}
            width="50%"
          >
            Yearly
          </Text>
        </Stack>
      </Stack>

      {active === "weekly" && <WeeklyEarningChart data={data} />}
      {active === "monthly" && <MonthlyEarningChart data={data} />}
      {active === "yearly" && <YearlyEarningChart data={data} />}
      <TotalEarningChart data={data} />
      <EarningsTable data={data} />
    </div>
  );
};

export default EarningChart;
